(function () {
  function bindRoot(root) {
    if (!root || root.getAttribute('data-mm-locations-bound')) return;
    root.setAttribute('data-mm-locations-bound', '1');
    var regions = root.querySelectorAll('[data-mm-loc-region]');
    var panels = root.querySelectorAll('[data-mm-loc-panel]');
    regions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-mm-loc-region');
        regions.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-mm-loc-panel') === id;
          p.classList.toggle('is-active', on);
          if (on) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      });
    });
  }
  function init() {
    document.querySelectorAll('[data-mm-locations]').forEach(bindRoot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
